import { Box } from "@mui/material";
import { PracticeProfileViewDto } from "libs/cellera-sdk";

import PracticeContactInfo from "./PracticeContactInfo";
import PracticeLogoHeader from "./PracticeLogoHeader";

interface PracticeViewDetailsProps {
  readonly practice: PracticeProfileViewDto;
  readonly onUpdateLogo?: () => void;
  readonly onUpdateName?: () => void;
}

function PracticeViewDetails({
  practice,
  onUpdateLogo,
  onUpdateName,
}: PracticeViewDetailsProps) {
  return (
    <Box className="space-y-6">
      <PracticeLogoHeader
        profilePicture={practice.logo || practice.profilePicture}
        practiceName={practice.practiceName}
        onUpdateLogo={onUpdateLogo}
        onUpdateName={onUpdateName}
      />

      <PracticeContactInfo
        email={practice.email}
        phoneNumber={practice.phoneNumber}
        faxNumber={practice.faxNumber}
      />
    </Box>
  );
}

export default PracticeViewDetails;
